import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import pollService from './pollService'
import { STATUS } from 'features/enums'

const errorMessage = (error) => {
    return (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
  }

const initialState = {
  polls: [],

  isPollsError: false,
  isPollsSuccess: false,
  isPollsLoading: false,
  pollErrorMessage: '',
 
  currentChoice: {
    pollId: "",
    _id: "",
    choice: "",
    arrayIndex: 0,
    votes: []
  },
 
  isPollUpdatedSuccess: false,
  isPollUpdatedLoading: false,

  isPollDeleteSuccess: false,
  isPollDeleteLoading: false,
  isPollDeleteError: false,
  pollDeleteErrorMessage: '',

  isPollCreatedSuccess: false,
  isPollCreatedLoading: false,
  isPollCreatedError: false,
  pollCreatedErrorMessage: '',

  isVoteError: false,
  isVoteLoading: false,
  isVoteSuccess: false,
  voteErrorMessage: '',

  pollResponseId: "",

  pollResponseStatus: STATUS.NOT_STARTED,
  viewResponsesStatus: STATUS.NOT_STARTED,
  updateViewSettingsStatus: STATUS.NOT_STARTED,

  responseData: [], 
  viewResponsesModal: {
    id: '',
    viewModal: false
  },

  totalPolls: 0,
  totalPages: 0,
  hasPrevPage: false,
  nextPage: null,
  pageNumber: 0,
  prevPage: null,  
  hasNextPage: false,
  hasFilter: false,
  filterValue: null,
  hasSortValue: null,
  sortValue: null,

  showCreatePollModal: false,
}

export const createPoll = createAsyncThunk(
    'polls/create',
    async (data, thunkAPI) => {
      try {
        const token = thunkAPI.getState().auth.user.token
        return await pollService.createPoll(data, token)
      } catch (error) {
      const message = errorMessage(error)
        return thunkAPI.rejectWithValue(message)
      }
    }
  )

  export const getPolls = createAsyncThunk(
    'polls/get',
    async (data, thunkAPI) => {
      try {
        const token = thunkAPI.getState().auth.user.token
        return await pollService.getPolls(data, token)
      } catch (error) {
      const message = errorMessage(error)
        return thunkAPI.rejectWithValue(message)
      }
    }
  )

  export const setPollResponse = createAsyncThunk(
    'polls/setPollResponse',
    async (data, thunkAPI) => {
      try {
        const token = thunkAPI.getState().auth.user.token
        return await pollService.setPollResponse(data, token)
      } catch (error) {
      const message = errorMessage(error)
        return thunkAPI.rejectWithValue(message)
      }
    }
  )

  export const deletePoll = createAsyncThunk(
    'polls/deletePoll',
    async (data, thunkAPI) => {
      try {
        const token = thunkAPI.getState().auth.user.token
        return await pollService.deletePoll(data, token)
      } catch (error) {
      const message = errorMessage(error)
        return thunkAPI.rejectWithValue(message)
      }
    }
  )


  export const updateViewSettings = createAsyncThunk(
    'polls/updateViewSettings',
    async (data, thunkAPI) => {
      try {
        const token = thunkAPI.getState().auth.user.token
        return await pollService.updateViewSettings(data, token)
      } catch (error) {
      const message = errorMessage(error)
        return thunkAPI.rejectWithValue(message)
      }
    }
  )

  export const viewResponses = createAsyncThunk(
    'polls/viewResponses',
    async (data, thunkAPI) => {
      try {
        const token = thunkAPI.getState().auth.user.token
        return await pollService.viewResponses(data, token)
      } catch (error) {
      const message = errorMessage(error)
        return thunkAPI.rejectWithValue(message)
      }
    }
  )

export  const pollSlice = createSlice({
    name: 'poll',
    initialState,
    reducers: {
        pollReset: (state) => initialState,

        setShowCreatePollModal: (state) => { state.showCreatePollModal = true },

        setCloseCreatePollModal: (state) => { state.showCreatePollModal = false },

        softPollReset: (state) => {
          state.isPollCreatedSuccess = false
          state.isPollCreatedLoading = false
          state.pollCreatedErrorMessage = false
          state.isPollCreatedError = ''
        },

        setCurrentChoice: (state, action) => {
          state.currentChoice = action.payload
        },
        setViewResponsesModal: (state, action) => {
          state.viewResponsesModal.pollId = action.payload.pollId
          state.viewResponsesModal.viewModal = action.payload.viewModal
        },
        resetPollResponseStatus: (state, action) => {
          state.pollResponseStatus = STATUS.NOT_STARTED
          state.pollResponseId = ""
          state.viewResponsesStatus = STATUS.NOT_STARTED
          state.currentChoice = {
            pollId: "",
            _id: "",
            choice: "",
            arrayIndex: 0,
            votes: []
          }
        },
        resetPollDeleteStatus: (state) => {
          state.isPollDeleteSuccess = false
          state.isPollDeleteLoading = false
          state.isPollDeleteError = false
          state.pollDeleteErrorMessage = ''
        }
    },
    extraReducers: (builder) => {
      builder
        .addCase(createPoll.pending, (state) => {
          state.isPollCreatedLoading = true
        })
        .addCase(createPoll.fulfilled, (state, action) => {
          state.polls.unshift(action.payload)
          state.isPollCreatedLoading = false
          state.isPollCreatedSuccess = true
        })
        .addCase(createPoll.rejected, (state, action) => {
            state.isPollCreatedLoading = false
            state.isPollCreatedError = true
            state.pollCreatedErrorMessage = action.payload
        })
        //------------------
        .addCase(getPolls.pending, (state) => {
            state.isPollsLoading = true
        })
        .addCase(getPolls.fulfilled, (state, action) => {
            state.isPollsLoading = false
            state.isPollsSuccess = true

            if(action.payload.pageNumber === 1) {
              state.polls = action.payload.pollsArray
            }else{
              state.polls.push(...action.payload.pollsArray)
            }
 
            state.totalPolls = action.payload.totalPolls
            state.totalPages = action.payload.totalPages
            state.pageNumber = action.payload.pageNumber
            state.hasNextPage = action.payload.hasNextPage
            state.prevPage = action.payload.previousPage
            state.nextPage = action.payload.nextPage 
            state.sortValue = action.payload.sortValue

        })
        .addCase(getPolls.rejected, (state, action) => {
            state.isPollsLoading = false
            state.isPollsError = true
            state.pollErrorMessage = action.payload
        })
        //------------------
        .addCase(setPollResponse.pending, (state, action) => {
            state.pollResponseStatus = STATUS.LOADING 
            state.pollResponseId = action.meta.arg.pollId
            state.voteErrorMessage = ''
        })
        .addCase(setPollResponse.fulfilled, (state, action) => { 
            state.pollResponseStatus = STATUS.SUCCESS
            state.polls[action.payload.index] = action.payload.updatedPoll
            state.currentChoice = {
              pollId: "",
              _id: "",
              choice: "",
              arrayIndex: 0,
              votes: []
            } 
        })
        .addCase(setPollResponse.rejected, (state, action) => {
          state.pollResponseStatus = STATUS.ERROR
            state.voteErrorMessage = action.payload 
        })
        //------------------
        .addCase(deletePoll.pending, (state) => {
          state.isPollDeleteLoading = true
          state.isPollDeleteSuccess = false
          state.isPollDeleteError = false
          state.pollDeleteErrorMessage = ''
        })
        .addCase(deletePoll.fulfilled, (state, action) => {
            state.isPollDeleteLoading = false
            state.isPollDeleteSuccess = true
            state.polls = state.polls.filter(
              (poll) => poll._id !== action.payload.id
            )
        })
        .addCase(deletePoll.rejected, (state, action) => {
            state.isPollDeleteLoading = false
            state.isPollDeleteError = true
            state.pollDeleteErrorMessage = action.payload
        })
      //------------------------------------------------------------------------------
      .addCase(updateViewSettings.pending, (state) => {
        state.updateViewSettingsStatus = STATUS.LOADING
      })
      .addCase(updateViewSettings.fulfilled, (state, action) => {
        state.updateViewSettingsStatus = STATUS.SUCCESS
        if(action.payload.index >= 0 && state.polls[action.payload.index]) {
          state.polls[action.payload.index] = action.payload.updatedPoll
        } else {
          const pollIndex = state.polls.findIndex((poll) => poll._id === action.payload.updatedPoll._id)
          if(pollIndex >= 0) {
            state.polls[pollIndex] = action.payload.updatedPoll
          }
        }
        if(state.responseData && state.responseData._id === action.payload.updatedPoll._id) {
          state.responseData.viewResults = action.payload.updatedPoll.viewResults
        }
      })
      .addCase(updateViewSettings.rejected, (state) => {
        state.updateViewSettingsStatus = STATUS.ERROR
      })
      //------------------------------------------------------------------------------
      .addCase(viewResponses.pending, (state) => {
        state.viewResponsesStatus = STATUS.LOADING
      })
      .addCase(viewResponses.fulfilled, (state, action) => {
        state.viewResponsesStatus = STATUS.SUCCESS
        state.responseData = action.payload.poll
      })
      .addCase(viewResponses.rejected, (state) => {
        state.viewResponsesStatus = STATUS.ERROR
      })
    },
})


export const { pollReset, setShowCreatePollModal, setCloseCreatePollModal, softPollReset, setCurrentChoice, setViewResponsesModal, resetPollResponseStatus, resetPollDeleteStatus } = pollSlice.actions
export default pollSlice.reducer
